@let showSlideout = showSlideoutSg();

@if (showSlideout) {
  @let isFocusedValuesModified =
    this.variablesFeature.selectors.isFocusedValuesModified.asSignal();
  @let isWidgetFocused = variablesFeature.selectors.isWidgetFocused.asSignal();
  @let hasPageVariables = hasPageVariablesSg();
  @let hasSessionVariables = hasSessionVariablesSg();

  <atn-ds-slideout-overlay name="Variables">
    <i
      class="atn-icon atn-close atn-red"
      actions
      (click)="cancelClickHandler()"
    ></i>
    <div class="atn-mosaic-variables-slideout">
      <div class="atn-mosaic-variables-slideout__content">
        @if (isWidgetFocused) {
          <div class="atn-mosaic-variables-slideout__variables">
            <atn-variables />
          </div>
        } @else {
          <atn-ds-integrated-horizontal-tabs
            (selectedTabChange)="handleTabChange($event)"
          >
            @if (hasPageVariables) {
              <ng-template
                atnDsTab
                name="Page"
              >
                <div class="atn-mosaic-variables-slideout__variables">
                  <atn-variables />
                </div>
              </ng-template>
            }

            @if (hasSessionVariables) {
              <ng-template
                atnDsTab
                name="App"
              >
                <div class="atn-mosaic-variables-slideout__variables">
                  <atn-variables />
                </div>
              </ng-template>
            }
          </atn-ds-integrated-horizontal-tabs>
        }
      </div>
      <div class="atn-mosaic-variables-slideout__footer">
        <div>
          @if (isFocusedValuesModified) {
            <a
              class="atn-mosaic-variables-slideout__footer-reset-link"
              (click)="resetClickHandler()"
              >Reset</a
            >
          }
        </div>

        <div class="atn-mosaic-variables-slideout__footer-buttons">
          <atn-ds-button
            type="transparent"
            (click)="cancelClickHandler()"
            >Cancel</atn-ds-button
          >
          <atn-ds-button (click)="applyClickHandler()">Apply</atn-ds-button>
        </div>
      </div>
    </div>
  </atn-ds-slideout-overlay>
}
